import { Button, Center, Spinner, Text, VStack } from '@chakra-ui/react'
import { ReactNode } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/typedReduxHooks'
import {
  AuthenticatedContextDependency,
  retryAuthenticatedContext,
} from './authenticatedContextSlice'

const dependencyLabels: Record<AuthenticatedContextDependency, string> = {
  currentOrganization: 'current organization',
  entitlements: 'organization entitlements',
  organizationUsers: 'organization users',
  currentClinic: 'current clinic',
}

export const AuthenticatedContextGate = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch()
  const { status, failedDependency } = useAppSelector((state) => state.authenticatedContext)

  if (status === 'ready') return <>{children}</>

  if (status === 'error') {
    return (
      <Center minH="100vh" bg="gray.50" p={6}>
        <VStack spacing={4} textAlign="center">
          <Text fontSize="xl" fontWeight="bold">
            RxPad context could not be loaded
          </Text>
          <Text>
            We could not load{' '}
            {failedDependency ? dependencyLabels[failedDependency] : 'your context'}. Your
            authenticated session is still active.
          </Text>
          <Button colorScheme="blue" onClick={() => dispatch(retryAuthenticatedContext())}>
            Retry
          </Button>
        </VStack>
      </Center>
    )
  }

  return (
    <Center minH="100vh" bg="gray.50">
      <VStack spacing={4}>
        <Spinner color="blue.500" size="xl" />
        <Text>Loading your RxPad context...</Text>
      </VStack>
    </Center>
  )
}
